import Home from './../components/home/Home';
import Config from './../constants/config';
import AccountAlreadyLinkedPage from './../pages/accountLinking/accountAlreadyLinked';
import NoEligibleAccountPage from './../pages/accountLinking/NoEligibleCard';
import TryLinkingAgainPage from './../pages/accountLinking/tryLinkingAgain';
import MultiCardPage from './../components/MultiCardPage/MultiCard';
import SingleCardPage from './../components/SingleCardPage/SingleCard';
import RaDeny from "./../pages/accountLinking/RaDeny";
import TechDiff from "../pages/accountLinking/TechDiff";
import NoContactChannel from "../pages/accountLinking/NoContactChannel";
import RedirectPage from "./../pages/accountLinking/RedirectPage";
import ContactChannels from "./../components/display-contact-channels/contactChannels";
import ValidateOOBCode from "./../pages/accountLinking/ValidateCode";
import TooManyCodesRequested from "./../components/redirection-accountLinking/TooManyCodesRequested";
import LockedOut from "./../components/redirection-accountLinking/lockedOut";
import TooManyOOBCodes from "./../components/redirection-accountLinking/TooManyOOBCodes";
import CardSecurePage from "../pages/accountLinking/CIDChallengepage";
import CIDLockOut from "./../components/redirection-accountLinking/CIDLockOut";
import ErrorPage from "./../pages/errorpage";
import MaxProvisionLimitPage from "./../pages/accountLinking/MaxProvisionLimit";

// const RedirectRoute = (props) => (
//   <Redirect to={ROUTES.PATH.HomePage} />
// );

// const PrivateRoute = (props) => (
//   <RedirectRoute />
// );

const ROUTES = {};
ROUTES.PATH = {
  HomePage: Config.Api_URL + "/" + Config.merchantName,
  NoEligibleAccountPage: Config.Api_URL + "/noeligibleaccount:"+Config.merchantName,
  TryLinkingAgainPage: Config.Api_URL + "/trylinkingagain:"+Config.merchantName,
  MultiCardPage: Config.Api_URL + "/multicardaccountlinking:"+Config.merchantName,
  AccountAlreadyLinkedPage: Config.Api_URL + "/alreadylinked:"+Config.merchantName,
  SingleCardPage: Config.Api_URL + "/singlecardaccountlinking:"+Config.merchantName,
  RaDeny: Config.Api_URL + "/radenypage:"+Config.merchantName,
  TechDiff: Config.Api_URL + "/techdiff:"+Config.merchantName,
  NoContactChannel: Config.Api_URL + "/nocontactchannel:"+Config.merchantName,
  RedirectPage: Config.Api_URL + "/redirect:"+Config.merchantName,
  ContactChannels: Config.Api_URL + "/contactchannels:"+Config.merchantName,
  ValidateCodePage: Config.Api_URL +"/validatecode:"+Config.merchantName,
  TooManyCodesRequestedPage: Config.Api_URL + "/toomanycodes:"+Config.merchantName,
  TooManyOOBCodesPage: Config.Api_URL + "/toomanyoobcodes:"+Config.merchantName,
  LockedOutPage: Config.Api_URL + "/lockout:"+Config.merchantName,
  CardSecurePage: Config.Api_URL + "/cardsecurepage:"+Config.merchantName,
  CIDLockOutPage: Config.Api_URL + "/cidlockout:"+Config.merchantName,
  ErrorPage: Config.Api_URL + "/refreshpage:"+Config.merchantName,
  MaxProvisionLimitPage: Config.Api_URL + "/maxprovisionlimit:"+Config.merchantName

};
ROUTES.DATA = [
  {
    path: ROUTES.PATH.HomePage,
    title: "API Provider Self-Service",
    //  breadcrumbLabel: "Self-Service Home",
    isExact: false,
    isParent: true,
    component: Home
  },
  {
    path: ROUTES.PATH.NoEligibleAccountPage,
    title: "NoEligible Card",
    //  breadcrumbLabel: "Self Validation",
    isExact: false,
    component: NoEligibleAccountPage
  },
  {
    path: ROUTES.PATH.TryLinkingAgainPage,
    title: "Try LinkingAgainPage",
    isExact: false,
    component: TryLinkingAgainPage
  },
  {
    path: ROUTES.PATH.MultiCardPage,
    title: "Account LinkingPage",
    isExact: false,
    component: MultiCardPage
  },
  {
    path: ROUTES.PATH.AccountAlreadyLinkedPage,
    title: "Account Already Linked Page",
    isExact: false,
    component: AccountAlreadyLinkedPage
  },
  {
    path: ROUTES.PATH.SingleCardPage,
    title: "One Account LinkingPage",
    isExact: false,
    component: SingleCardPage
  },
  {
    path: ROUTES.PATH.RaDeny,
    title: "RA Deny Page",
    isExact: false,
    component: RaDeny
  },
  {
    path: ROUTES.PATH.TechDiff,
    title: "Technical Difficulty Page",
    isExact: false,
    component: TechDiff
  },
  {
    path: ROUTES.PATH.MaxProvisionLimitPage,
    title: "Max Provision Limit Page",
    isExact: false,
    component: MaxProvisionLimitPage
  },
  {
    path: ROUTES.PATH.NoContactChannel,
    title: "No Contact Channel Page",
    isExact: false,
    component: NoContactChannel
  },
  {
    path: ROUTES.PATH.RedirectPage,
    title: "Redirect Page",
    isExact: false,
    component: RedirectPage
  },
  {
    path: ROUTES.PATH.ContactChannels,
    title: "Display Contact channels",
    isExact: false,
    component: ContactChannels
  },
  {
    path: ROUTES.PATH.ValidateCodePage,
    title: "Validate Code",
    isExact: false,
    component: ValidateOOBCode
  },
  {
    path: ROUTES.PATH.TooManyCodesRequestedPage,
    title: "Too Many Codes",
    isExact: false,
    component: TooManyCodesRequested
  },
  {
    path: ROUTES.PATH.TooManyOOBCodesPage,
    title: "Too Many OOB Codes",
    isExact: false,
    component: TooManyOOBCodes
  },
  {
    path: ROUTES.PATH.LockedOutPage,
    title: "Too Many Codes",
    isExact: false,
    component: LockedOut
  },
  {
    path: ROUTES.PATH.CardSecurePage,
    title: "CID page",
    isExact: false,
    component: CardSecurePage
  },
  {
    path: ROUTES.PATH.CIDLockOutPage,
    title: "CID Locked Out",
    isExact: false,
    component: CIDLockOut
  },
  {
    path: ROUTES.PATH.ErrorPage,
    title: "Error page",
    isExact: false,
    component: ErrorPage
  }
];

export default ROUTES;
